<app-public-header></app-public-header>

<router-outlet></router-outlet>

<app-public-footer></app-public-footer>